/* eslint-disable global-require */
import {
	CmsAppFeatureData,
	CmsAppPromoData,
	CmsBannersData,
	CmsDiscoverSalonData,
	CmsDiscoverServiceData,
	CmsHeroData,
	CmsHomeMetadata,
	CmsLoginAndRegistrationBannerData,
	CmsNpForBusinessData,
	CmsNpStatisticsData,
	CmsNpTestimonialsData,
	CmsParameterSelectionBannerData,
	CmsReservationDetailData,
	CmsSalonListSmallBannerData,
	CmsSalonsMetadata,
	CmsThankYouPageBannerData
} from '../types/types'
import { getAppContext } from './getAppContext'
import { getIntl } from './intl'

export const HERO_SECTION_FALLBACKS = (): CmsHeroData => {
	const { formatMessage } = getIntl()
	const { assetsPath } = getAppContext()

	return {
		title: formatMessage({ id: 'cms-fallbacks-hero-section-title' }),
		subtitle: formatMessage({ id: 'cms-fallbacks-hero-section-subtitle' }),
		background: {
			desktop: `${assetsPath}/${require('../assets/images/cms-fallbacks/hero-section/hero-section-bg-desktop.jpg')}`,
			mobile: `${assetsPath}/${require('../assets/images/cms-fallbacks/hero-section/hero-section-bg-mobile.jpg')}`,
			desktopWebP: `${assetsPath}/${require('../assets/images/cms-fallbacks/hero-section/hero-section-bg-desktop.webp')}`,
			mobileWebP: `${assetsPath}/${require('../assets/images/cms-fallbacks/hero-section/hero-section-bg-mobile.webp')}`
		}
	}
}

export const APP_PROMO_FALLBACKS = (): CmsAppPromoData => {
	const { locale, formatMessage } = getIntl()
	const { assetsPath } = getAppContext()

	const commonData = {
		title: formatMessage({ id: 'cms-fallbacks-app-promo-title' }),
		subtitle: formatMessage({ id: 'cms-fallbacks-app-promo-subtitle' }),
		background: {
			desktop: `${assetsPath}/${require('../assets/images/cms-fallbacks/app-promo/app-promo-bg-desktop.jpg')}`,
			mobile: `${assetsPath}/${require('../assets/images/cms-fallbacks/app-promo/app-promo-bg-mobile.jpg')}`,
			desktopWebP: `${assetsPath}/${require('../assets/images/cms-fallbacks/app-promo/app-promo-bg-desktop.webp')}`,
			mobileWebP: `${assetsPath}/${require('../assets/images/cms-fallbacks/app-promo/app-promo-bg-mobile.webp')}`
		},
		tooltip: formatMessage({ id: 'cms-fallbacks-app-promo-tooltip' })
	}

	const commonVideoThumbnailData = {
		alt: formatMessage({ id: 'cms-fallbacks-app-promo-image-alt' }),
		link: undefined,
		trackingID: undefined
	}

	switch (locale) {
		case 'bg':
		case 'hu': {
			return {
				...commonData,
				videoThumbnail: {
					...commonVideoThumbnailData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-lg-all.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-lg-all.webp`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-sm-all.jpg`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-sm-all.webp`)}`
				}
			}
		}
		case 'ro': {
			return {
				...commonData,
				videoThumbnail: {
					...commonVideoThumbnailData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-lg-ro.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-lg-ro.webp`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-sm-ro.jpg`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-sm-ro.webp`)}`
				}
			}
		}
		case 'sk': {
			return {
				...commonData,
				videoThumbnail: {
					...commonVideoThumbnailData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-lg-sk.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-lg-sk.webp`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-sm-sk.jpg`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-sm-sk.webp`)}`
				},
				video: {
					width: 960,
					height: 600,
					url: 'https://dmrz39codqjlj.cloudfront.net/static/WSK_SK_kristina-banner_960x600.mp4',
					name: 'WSK_SK_kristina-banner_960x600.mp4'
				}
			}
		}
		case 'cs': {
			return {
				...commonData,
				videoThumbnail: {
					...commonVideoThumbnailData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-lg-cs.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-lg-cs.webp`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-sm-cs.jpg`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-sm-cs.webp`)}`
				},
				video: {
					width: 960,
					height: 600,
					url: 'https://dmrz39codqjlj.cloudfront.net/static/WSK_CZ_ewa-banner_960x600.mp4',
					name: 'WSK_CZ_ewa-banner_960x600.mp4'
				}
			}
		}
		case 'de-AT':
		case 'hr':
		default: {
			return {
				...commonData,
				videoThumbnail: {
					...commonVideoThumbnailData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-lg-default.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-lg-default.webp`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-sm-default.jpg`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-promo/app-promo-preview-sm-default.webp`)}`
				}
			}
		}
	}
}

export const DISCOVER_SALON_FALLBACKS = (): CmsDiscoverSalonData => {
	const { locale, formatMessage } = getIntl()
	const { assetsPath } = getAppContext()

	const commonData = {
		title: formatMessage({ id: 'cms-fallbacks-discover-salon-title' }),
		subtitle: formatMessage({ id: 'cms-fallbacks-discover-salon-subtitle' })
	}

	const commonImageData = {
		alt: formatMessage({ id: 'cms-fallbacks-discover-salon-image-alt' }),
		link: undefined,
		trackingID: undefined
	}

	switch (locale) {
		case 'bg': {
			return {
				...commonData,
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-lg-bg.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-lg-bg.webp`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-sm-bg.jpg`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-sm-bg.webp`)}`
				}
			}
		}
		case 'hu': {
			return {
				...commonData,
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-lg-hu.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-lg-hu.webp`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-sm-hu.jpg`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-sm-hu.webp`)}`
				}
			}
		}
		case 'ro': {
			return {
				...commonData,
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-lg-ro.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-lg-ro.webp`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-sm-ro.jpg`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-sm-ro.webp`)}`
				}
			}
		}
		case 'sk': {
			return {
				...commonData,
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-lg-sk.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-lg-sk.webp`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-sm-sk.jpg`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-sm-sk.webp`)}`
				}
			}
		}
		case 'hr': {
			return {
				...commonData,
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-lg-hr.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-lg-hr.webp`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-sm-hr.jpg`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-sm-hr.webp`)}`
				}
			}
		}
		case 'de-AT': {
			return {
				...commonData,
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-lg-de-AT.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-lg-de-AT.webp`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-sm-de-AT.jpg`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-sm-de-AT.webp`)}`
				}
			}
		}
		case 'cs':
		default: {
			return {
				...commonData,
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-lg-cs.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-lg-cs.webp`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-sm-cs.jpg`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/discover-salon/discover-salon-image-sm-cs.webp`)}`
				}
			}
		}
	}
}

export const DISCOVER_SERVICE_FALLBACKS = (): CmsDiscoverServiceData => {
	const { formatMessage } = getIntl()

	return {
		title: formatMessage({ id: 'cms-fallbacks-discover-service-title' }),
		subtitle: formatMessage({ id: 'cms-fallbacks-discover-service-subtitle' })
	}
}

export const APP_FEATURE_FALLBACKS = (): CmsAppFeatureData => {
	const { locale, formatMessage } = getIntl()
	const { assetsPath } = getAppContext()

	const commonData = {
		title: formatMessage({ id: 'cms-fallbacks-app-feature-title' }),
		subtitle: {
			desktop: formatMessage({ id: 'cms-fallbacks-app-feature-subtitle-desktop' }),
			mobile: formatMessage({ id: 'cms-fallbacks-app-feature-subtitle-mobile' })
		}
	}

	const commonImage1Data = {
		alt: formatMessage({ id: 'cms-fallbacks-app-feature-image-1-alt' }),
		link: undefined,
		trackingID: undefined
	}

	const commonImage2Data = {
		alt: formatMessage({ id: 'cms-fallbacks-app-feature-image-2-alt' }),
		link: undefined,
		trackingID: undefined
	}

	const commonImage3Data = {
		alt: formatMessage({ id: 'cms-fallbacks-app-feature-image-3-alt' }),
		link: undefined,
		trackingID: undefined
	}

	const commonImage4Data = {
		alt: formatMessage({ id: 'cms-fallbacks-app-feature-image-4-alt' }),
		link: undefined,
		trackingID: undefined
	}

	const commonImage5Data = {
		alt: formatMessage({ id: 'cms-fallbacks-app-feature-image-5-alt' }),
		link: undefined,
		trackingID: undefined
	}

	switch (locale) {
		case 'bg': {
			return {
				...commonData,
				image1: {
					...commonImage1Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-bg.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-bg.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-bg.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-bg.webp`)}`
				},
				image2: {
					...commonImage2Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-bg.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-bg.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-bg.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-bg.webp`)}`
				},
				image3: {
					...commonImage3Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-bg.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-bg.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-bg.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-bg.webp`)}`
				},
				image4: {
					...commonImage4Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-bg.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-bg.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-bg.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-bg.webp`)}`
				},
				image5: {
					...commonImage5Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-bg.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-bg.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-bg.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-bg.webp`)}`
				}
			}
		}
		case 'hu': {
			return {
				...commonData,
				image1: {
					...commonImage1Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-hu.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-hu.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-hu.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-hu.webp`)}`
				},
				image2: {
					...commonImage2Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-hu.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-hu.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-hu.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-hu.webp`)}`
				},
				image3: {
					...commonImage3Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-hu.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-hu.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-hu.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-hu.webp`)}`
				},
				image4: {
					...commonImage4Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-hu.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-hu.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-hu.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-hu.webp`)}`
				},
				image5: {
					...commonImage5Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-hu.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-hu.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-hu.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-hu.webp`)}`
				}
			}
		}
		case 'ro': {
			return {
				...commonData,
				image1: {
					...commonImage1Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-ro.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-ro.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-ro.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-ro.webp`)}`
				},
				image2: {
					...commonImage2Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-ro.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-ro.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-ro.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-ro.webp`)}`
				},
				image3: {
					...commonImage3Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-ro.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-ro.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-ro.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-ro.webp`)}`
				},
				image4: {
					...commonImage4Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-ro.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-ro.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-ro.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-ro.webp`)}`
				},
				image5: {
					...commonImage5Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-ro.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-ro.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-ro.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-ro.webp`)}`
				}
			}
		}
		case 'sk': {
			return {
				...commonData,
				image1: {
					...commonImage1Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-sk.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-sk.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-sk.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-sk.webp`)}`
				},
				image2: {
					...commonImage2Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-sk.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-sk.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-sk.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-sk.webp`)}`
				},
				image3: {
					...commonImage3Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-sk.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-sk.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-sk.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-sk.webp`)}`
				},
				image4: {
					...commonImage4Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-sk.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-sk.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-sk.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-sk.webp`)}`
				},
				image5: {
					...commonImage5Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-sk.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-sk.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-sk.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-sk.webp`)}`
				}
			}
		}
		case 'hr': {
			return {
				...commonData,
				image1: {
					...commonImage1Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-hr.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-hr.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-hr.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-hr.webp`)}`
				},
				image2: {
					...commonImage2Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-hr.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-hr.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-hr.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-hr.webp`)}`
				},
				image3: {
					...commonImage3Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-hr.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-hr.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-hr.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-hr.webp`)}`
				},
				image4: {
					...commonImage4Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-hr.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-hr.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-hr.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-hr.webp`)}`
				},
				image5: {
					...commonImage5Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-hr.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-hr.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-hr.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-hr.webp`)}`
				}
			}
		}
		case 'de-AT': {
			return {
				...commonData,
				image1: {
					...commonImage1Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-de-AT.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-de-AT.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-de-AT.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-de-AT.webp`)}`
				},
				image2: {
					...commonImage2Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-de-AT.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-de-AT.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-de-AT.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-de-AT.webp`)}`
				},
				image3: {
					...commonImage3Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-de-AT.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-de-AT.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-de-AT.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-de-AT.webp`)}`
				},
				image4: {
					...commonImage4Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-de-AT.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-de-AT.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-de-AT.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-de-AT.webp`)}`
				},
				image5: {
					...commonImage5Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-de-AT.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-de-AT.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-de-AT.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-de-AT.webp`)}`
				}
			}
		}
		case 'cs':
		default: {
			return {
				...commonData,
				image1: {
					...commonImage1Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-cs.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-cs.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-cs.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-1-cs.webp`)}`
				},
				image2: {
					...commonImage2Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-cs.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-cs.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-cs.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-2-cs.webp`)}`
				},
				image3: {
					...commonImage3Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-cs.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-cs.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-cs.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-3-cs.webp`)}`
				},
				image4: {
					...commonImage4Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-cs.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-cs.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-cs.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-4-cs.webp`)}`
				},
				image5: {
					...commonImage5Data,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-cs.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-cs.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-cs.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/app-feature/app-feature-5-cs.webp`)}`
				}
			}
		}
	}
}

export const TESTIMONIALS_FALLBACKS = (): CmsNpTestimonialsData => {
	const { formatMessage } = getIntl()

	return {
		title: formatMessage({ id: 'cms-fallbacks-testimonials-title' }),
		testimonials: [
			{
				ratingId: 'review-1',
				rating: 5,
				name: formatMessage({ id: 'cms-fallbacks-testimonial-1-reviewer-name' }),
				title: formatMessage({ id: 'cms-fallbacks-testimonial-1-title' }),
				text: formatMessage({ id: 'cms-fallbacks-testimonial-1-text' })
			},
			{
				ratingId: 'review-2',
				rating: 5,
				name: formatMessage({ id: 'cms-fallbacks-testimonial-2-reviewer-name' }),
				title: formatMessage({ id: 'cms-fallbacks-testimonial-2-title' }),
				text: formatMessage({ id: 'cms-fallbacks-testimonial-2-text' })
			},
			{
				ratingId: 'review-3',
				rating: 5,
				name: formatMessage({ id: 'cms-fallbacks-testimonial-3-reviewer-name' }),
				title: formatMessage({ id: 'cms-fallbacks-testimonial-3-title' }),
				text: formatMessage({ id: 'cms-fallbacks-testimonial-3-text' })
			}
		]
	}
}

export const NP_STATISTICS_FALLBACKS = (): CmsNpStatisticsData => {
	return {
		professionalsStatistics: {
			isRichText: false,
			data: {
				message: 'cms-fallbacks-np-statistics-professionals'
			}
		},
		salonsStatistics: {
			isRichText: false,
			data: {
				message: 'cms-fallbacks-np-statistics-salons'
			}
		},
		reservationsStatistics: {
			isRichText: false,
			data: {
				message: 'cms-fallbacks-np-statistics-reservations'
			}
		}
	}
}

export const HOME_METADATA_FALLBACKS = (): CmsHomeMetadata => {
	const { formatMessage } = getIntl()
	return {
		metaTitle: formatMessage({ id: 'SEO - Homepage - meta title' }),
		metaDescription: formatMessage({ id: 'SEO - Homepage - meta description' }),
		metaKeywords: formatMessage({ id: 'SEO - Homepage - meta keywords' })
	}
}

export const SALONS_LIST_METADATA_FALLBACKS = (): CmsSalonsMetadata => {
	const { formatMessage } = getIntl()

	return {
		metaTitle: formatMessage({ id: 'SEO - Salons list page - title' }),
		metaDescription: formatMessage({ id: 'SEO - Salons List page - meta description' }),
		metaKeywords: formatMessage({ id: 'SEO - Salons List page - meta keywords' }),
		indexPage: true,
		deactivatePage: false,
		pageTitle: formatMessage({ id: 'List of salons' }),
		content: {
			isRichText: false,
			data: null
		},
		citiesContent: undefined,
		cities: undefined,
		servicesContent: undefined
	}
}

export const SALONS_CATEGORY_METADATA_FALLBACKS = (categoryID: string, categoryName: string, citySlug: string | undefined): CmsSalonsMetadata => {
	// NOTE: for the city-specific category pages, we use the generic salons list metadata fallbacks
	if (citySlug) {
		return SALONS_LIST_METADATA_FALLBACKS()
	}

	const intl = getIntl()

	const commonData = {
		deactivatePage: false,
		indexPage: true,
		pageTitle: categoryName,
		cities: undefined,
		citiesContent: undefined,
		servicesContent: undefined
	}

	switch (categoryID) {
		// categoryName: "Women's hairdressing",
		case '00000000-0000-0000-0000-000000000001': {
			return {
				...commonData,
				metaTitle: intl.formatMessage({ id: 'SEO - Category page - Womens hairdressing - meta title' }, { categoryName }),
				metaDescription: intl.formatMessage({ id: 'SEO - Category page - Womens hairdressing - meta description' }),
				metaKeywords: intl.formatMessage({ id: 'SEO - Category page - Womens hairdressing - meta keywords' }),
				content: {
					isRichText: false,
					data: {
						// NOTE: this translations contains HTML content, so we need to use React component to render it. But return JSX here is not valid, so we return the message ID here and use it in the component to get the actual content.
						descriptionMessageID: 'SEO - Category page - Womens hairdressing - category description',
						descriptionTitle: intl.formatMessage({ id: 'SEO - Category page - Womens hairdressing - category description title' })
					}
				}
			}
		}
		// categoryName: "Men's hairdressing",
		case '00000000-0000-0000-0000-000000000002': {
			return {
				...commonData,
				metaTitle: intl.formatMessage({ id: 'SEO - Category page - Mens hairdressing - meta title' }, { categoryName }),
				metaDescription: intl.formatMessage({ id: 'SEO - Category page - Mens hairdressing - meta description' }),
				metaKeywords: intl.formatMessage({ id: 'SEO - Category page - Mens hairdressing - meta keywords' }),
				content: {
					isRichText: false,
					data: {
						// NOTE: this translations contains HTML content, so we need to use React component to render it. But return JSX here is not valid, so we return the message ID here and use it in the component to get the actual content.
						descriptionMessageID: 'SEO - Category page - Mens hairdressing - category description',
						descriptionTitle: intl.formatMessage({ id: 'SEO - Category page - Mens hairdressing - category description title' })
					}
				}
			}
		}
		// categoryName: "Children's hairdressing",
		case '00000000-0000-0000-0000-000000000003': {
			return {
				...commonData,
				metaTitle: intl.formatMessage({ id: 'SEO - Category page - Childrens hairdressing - meta title' }, { categoryName }),
				metaDescription: intl.formatMessage({ id: 'SEO - Category page - Childrens hairdressing - meta description' }),
				metaKeywords: intl.formatMessage({ id: 'SEO - Category page - Childrens hairdressing - meta keywords' }),
				content: {
					isRichText: false,
					data: {
						// NOTE: this translations contains HTML content, so we need to use React component to render it. But return JSX here is not valid, so we return the message ID here and use it in the component to get the actual content.
						descriptionMessageID: 'SEO - Category page - Childrens hairdressing - category description',
						descriptionTitle: intl.formatMessage({ id: 'SEO - Category page - Childrens hairdressing - category description title' })
					}
				}
			}
		}
		// categoryName: 'Barber shop',
		case '00000000-0000-0000-0000-000000000004': {
			return {
				...commonData,
				metaTitle: intl.formatMessage({ id: 'SEO - Category page - Barber shop - meta title' }, { categoryName }),
				metaDescription: intl.formatMessage({ id: 'SEO - Category page - Barber shop - meta description' }),
				metaKeywords: intl.formatMessage({ id: 'SEO - Category page - Barber shop - meta keywords' }),
				content: {
					isRichText: false,
					data: {
						// NOTE: this translations contains HTML content, so we need to use React component to render it. But return JSX here is not valid, so we return the message ID here and use it in the component to get the actual content.
						descriptionMessageID: 'SEO - Category page - Barber shop - category description',
						descriptionTitle: intl.formatMessage({ id: 'SEO - Category page - Barber shop - category description title' })
					}
				}
			}
		}
		// categoryName: 'Cosmetic services',
		case '00000000-0000-0000-0000-000000000005': {
			return {
				...commonData,
				metaTitle: intl.formatMessage({ id: 'SEO - Category page - Cosmetic services - meta title' }, { categoryName }),
				metaDescription: intl.formatMessage({ id: 'SEO - Category page - Cosmetic services - meta description' }),
				metaKeywords: intl.formatMessage({ id: 'SEO - Category page - Cosmetic services - meta keywords' }),
				content: {
					isRichText: false,
					data: {
						// NOTE: this translations contains HTML content, so we need to use React component to render it. But return JSX here is not valid, so we return the message ID here and use it in the component to get the actual content.
						descriptionMessageID: 'SEO - Category page - Cosmetic services - category description',
						descriptionTitle: intl.formatMessage({ id: 'SEO - Category page - Cosmetic services - category description title' })
					}
				}
			}
		}
		// categoryName: 'Massage & physiotherapy',
		case '00000000-0000-0000-0000-000000000006': {
			return {
				...commonData,
				metaTitle: intl.formatMessage({ id: 'SEO - Category page - Massage and physiotherapy - meta title' }, { categoryName }),
				metaDescription: intl.formatMessage({ id: 'SEO - Category page - Massage and physiotherapy - meta description' }),
				metaKeywords: intl.formatMessage({ id: 'SEO - Category page - Massage and physiotherapy - meta keywords' }),
				content: {
					isRichText: false,
					data: {
						// NOTE: this translations contains HTML content, so we need to use React component to render it. But return JSX here is not valid, so we return the message ID here and use it in the component to get the actual content.
						descriptionMessageID: 'SEO - Category page - Massage and physiotherapy - category description',
						descriptionTitle: intl.formatMessage({ id: 'SEO - Category page - Massage and physiotherapy - category description title' })
					}
				}
			}
		}
		// categoryName: 'Aesthetic services',
		case '00000000-0000-0000-0000-000000000007': {
			return {
				...commonData,
				metaTitle: intl.formatMessage({ id: 'SEO - Category page - Aesthetic services - meta title' }, { categoryName }),
				metaDescription: intl.formatMessage({ id: 'SEO - Category page - Aesthetic services - meta description' }),
				metaKeywords: intl.formatMessage({ id: 'SEO - Category page - Aesthetic services - meta keywords' }),
				content: {
					isRichText: false,
					data: {
						// NOTE: this translations contains HTML content, so we need to use React component to render it. But return JSX here is not valid, so we return the message ID here and use it in the component to get the actual content.
						descriptionMessageID: 'SEO - Category page - Aesthetic services - category description',
						descriptionTitle: intl.formatMessage({ id: 'SEO - Category page - Aesthetic services - category description title' })
					}
				}
			}
		}
		// categoryName: 'Manicure & pedicure',
		case '00000000-0000-0000-0000-000000000008': {
			return {
				...commonData,
				metaTitle: intl.formatMessage({ id: 'SEO - Category page - Manicure and pedicure - meta title' }, { categoryName }),
				metaDescription: intl.formatMessage({ id: 'SEO - Category page - Manicure and pedicure - meta description' }),
				metaKeywords: intl.formatMessage({ id: 'SEO - Category page - Manicure and pedicure - meta keywords' }),
				content: {
					isRichText: false,
					data: {
						// NOTE: this translations contains HTML content, so we need to use React component to render it. But return JSX here is not valid, so we return the message ID here and use it in the component to get the actual content.
						descriptionMessageID: 'SEO - Category page - Manicure and pedicure - category description',
						descriptionTitle: intl.formatMessage({ id: 'SEO - Category page - Manicure and pedicure - category description title' })
					}
				}
			}
		}
		// categoryName: 'Pet salons',
		case '00000000-0000-0000-0000-000000000009': {
			return {
				...commonData,
				metaTitle: intl.formatMessage({ id: 'SEO - Category page - Pet salons - meta title' }, { categoryName }),
				metaDescription: intl.formatMessage({ id: 'SEO - Category page - Pet salons - meta description' }),
				metaKeywords: intl.formatMessage({ id: 'SEO - Category page - Pet salons - meta keywords' }),
				content: {
					isRichText: false,
					data: {
						// NOTE: this translations contains HTML content, so we need to use React component to render it. But return JSX here is not valid, so we return the message ID here and use it in the component to get the actual content.
						descriptionMessageID: 'SEO - Category page - Pet salons - category description',
						descriptionTitle: intl.formatMessage({ id: 'SEO - Category page - Pet salons - category description title' })
					}
				}
			}
		}
		// categoryName: 'Tanning salons & sunbeds',
		case '2950610d-c9ec-484d-8c33-115a52e6bd42': {
			return {
				...commonData,
				metaTitle: intl.formatMessage({ id: 'SEO - Category page - Tanning salons and sunbeds - meta title' }, { categoryName }),
				metaDescription: intl.formatMessage({ id: 'SEO - Category page - Tanning salons and sunbeds - meta description' }),
				metaKeywords: intl.formatMessage({ id: 'SEO - Category page - Tanning salons and sunbeds - meta keywords' }),
				content: {
					isRichText: false,
					data: {
						// NOTE: this translations contains HTML content, so we need to use React component to render it. But return JSX here is not valid, so we return the message ID here and use it in the component to get the actual content.
						descriptionMessageID: 'SEO - Category page - Tanning salons and sunbeds - category description',
						descriptionTitle: intl.formatMessage({ id: 'SEO - Category page - Tanning salons and sunbeds - category description title' })
					}
				}
			}
		}
		// categoryName: 'Tattoos & piercings',
		case '8cb2ed99-a83f-45cc-8c50-7c47eec7a5a2': {
			return {
				...commonData,
				metaTitle: intl.formatMessage({ id: 'SEO - Category page - Tattoos and piercings - meta title' }, { categoryName }),
				metaDescription: intl.formatMessage({ id: 'SEO - Category page - Tattoos and piercings - meta description' }),
				metaKeywords: intl.formatMessage({ id: 'SEO - Category page - Tattoos and piercings - meta keywords' }),
				content: {
					isRichText: false,
					data: {
						// NOTE: this translations contains HTML content, so we need to use React component to render it. But return JSX here is not valid, so we return the message ID here and use it in the component to get the actual content.
						descriptionMessageID: 'SEO - Category page - Tattoos and piercings - category description',
						descriptionTitle: intl.formatMessage({ id: 'SEO - Category page - Tattoos and piercings - category description title' })
					}
				}
			}
		}
		// categoryName: 'Aesthetic medicine',
		case 'cbf2934d-49ad-409e-a283-ac4a8b060eca': {
			return {
				...commonData,
				metaTitle: intl.formatMessage({ id: 'SEO - Category page - Aesthetic medicine - meta title' }, { categoryName }),
				metaDescription: intl.formatMessage({ id: 'SEO - Category page - Aesthetic medicine - meta description' }),
				metaKeywords: intl.formatMessage({ id: 'SEO - Category page - Aesthetic medicine - meta keywords' }),
				content: {
					isRichText: false,
					data: {
						// NOTE: this translations contains HTML content, so we need to use React component to render it. But return JSX here is not valid, so we return the message ID here and use it in the component to get the actual content.
						descriptionMessageID: 'SEO - Category page - Aesthetic medicine - category description',
						descriptionTitle: intl.formatMessage({ id: 'SEO - Category page - Aesthetic medicine - category description title' })
					}
				}
			}
		}
		default: {
			return {
				...commonData,
				metaTitle: intl.formatMessage(
					{
						id: 'SEO - Category page - fallback meta title',
						defaultMessage: '{ categoryName } | Notino Partner'
					},
					{ categoryName }
				),
				metaDescription: intl.formatMessage({ id: 'SEO - Category page - fallback meta description' }),
				metaKeywords: intl.formatMessage({ id: 'SEO - Category page - fallback meta keywords' }),
				content: {
					isRichText: false,
					data: null
				}
			}
		}
	}
}

export const NP_FOR_BUSINESSES_FALLBACKS = (): CmsNpForBusinessData => {
	const { locale, formatMessage } = getIntl()
	const { assetsPath } = getAppContext()

	const commonData = {
		backgroundImage: `${assetsPath}/${require('../assets/images/cms-fallbacks/np-for-business/np-for-business-bg.jpg')}`,
		backgroundImageWebP: `${assetsPath}/${require('../assets/images/cms-fallbacks/np-for-business/np-for-business-bg.webp')}`
	}

	const commonImageData = {
		alt: formatMessage({ id: 'cms-fallbacks-nb-for-businesses-image-alt' }),
		trackingID: undefined
	}

	switch (locale) {
		case 'bg': {
			return {
				...commonData,
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-desktop-bg.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-mobile-bg.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-desktop-bg.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-mobile-bg.webp`)}`,
					link: 'https://bit.ly/4hUAhVl'
				}
			}
		}
		case 'hu': {
			return {
				...commonData,
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-desktop-hu.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-mobile-hu.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-desktop-hu.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-mobile-hu.webp`)}`,
					link: 'https://bit.ly/3QCdr9g'
				}
			}
		}
		case 'ro': {
			return {
				...commonData,
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-desktop-ro.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-mobile-ro.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-desktop-ro.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-mobile-ro.webp`)}`,
					link: 'https://bit.ly/4iaRQ3g'
				}
			}
		}
		case 'sk': {
			return {
				...commonData,
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-desktop-sk.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-mobile-sk.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-desktop-sk.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-mobile-sk.webp`)}`,
					link: 'https://bit.ly/4bjSTLW'
				}
			}
		}
		case 'hr': {
			return {
				...commonData,
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-desktop-hr.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-mobile-hr.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-desktop-hr.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-mobile-hr.webp`)}`,
					link: 'https://partner.notino.hr/'
				}
			}
		}
		case 'de-AT': {
			return {
				...commonData,
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-desktop-de-AT.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-mobile-de-AT.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-desktop-de-AT.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-mobile-de-AT.webp`)}`,
					link: 'https://partner.notino.at/'
				}
			}
		}
		case 'cs':
		default: {
			return {
				...commonData,
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-desktop-cs.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-mobile-cs.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-desktop-cs.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/np-for-business/np-for-business-banner-mobile-cs.webp`)}`,
					link: 'https://bit.ly/43bspdA'
				}
			}
		}
	}
}

export const SALON_LIST_SMALL_BANNER_FALLBACKS = (): CmsSalonListSmallBannerData => {
	const { locale, formatMessage } = getIntl()
	const { assetsPath } = getAppContext()

	const commonImageData = {
		alt: formatMessage({ id: 'cms-fallbacks-salon-list-small-promo-banner-alt' }),
		trackingID: undefined
	}

	switch (locale) {
		case 'bg': {
			const desktop = `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-list-small-banner/salon-list-small-banner-bg.jpg`)}`
			const desktopWebP = `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-list-small-banner/salon-list-small-banner-bg.webp`)}`
			const mobile = desktop
			const mobileWebP = desktopWebP

			return {
				image: {
					...commonImageData,
					desktop,
					mobile,
					desktopWebP,
					mobileWebP,
					link: 'https://bit.ly/4i6Ivty'
				}
			}
		}
		case 'hu': {
			const desktop = `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-list-small-banner/salon-list-small-banner-hu.jpg`)}`
			const desktopWebP = `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-list-small-banner/salon-list-small-banner-hu.webp`)}`
			const mobile = desktop
			const mobileWebP = desktopWebP

			return {
				image: {
					...commonImageData,
					desktop,
					mobile,
					desktopWebP,
					mobileWebP,
					link: 'https://bit.ly/43cTtsZ'
				}
			}
		}
		case 'ro': {
			const desktop = `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-list-small-banner/salon-list-small-banner-ro.jpg`)}`
			const desktopWebP = `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-list-small-banner/salon-list-small-banner-ro.webp`)}`
			const mobile = desktop
			const mobileWebP = desktopWebP

			return {
				image: {
					...commonImageData,
					desktop,
					mobile,
					desktopWebP,
					mobileWebP,
					link: 'https://bit.ly/43gEzC3'
				}
			}
		}
		case 'sk': {
			const desktop = `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-list-small-banner/salon-list-small-banner-sk.jpg`)}`
			const desktopWebP = `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-list-small-banner/salon-list-small-banner-sk.webp`)}`
			const mobile = desktop
			const mobileWebP = desktopWebP

			return {
				image: {
					...commonImageData,
					desktop,
					mobile,
					desktopWebP,
					mobileWebP,
					link: 'https://bit.ly/4hSvfZr'
				}
			}
		}
		case 'de-AT': {
			const desktop = `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-list-small-banner/salon-list-small-banner-de-AT.jpg`)}`
			const desktopWebP = `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-list-small-banner/salon-list-small-banner-de-AT.webp`)}`
			const mobile = desktop
			const mobileWebP = desktopWebP

			return {
				image: {
					...commonImageData,
					desktop,
					mobile,
					desktopWebP,
					mobileWebP,
					link: 'https://www.notino.at/salons-promo/'
				}
			}
		}
		case 'hr': {
			const desktop = `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-list-small-banner/salon-list-small-banner-hr.jpg`)}`
			const desktopWebP = `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-list-small-banner/salon-list-small-banner-hr.webp`)}`
			const mobile = desktop
			const mobileWebP = desktopWebP

			return {
				image: {
					...commonImageData,
					desktop,
					mobile,
					desktopWebP,
					mobileWebP,
					link: 'https://www.notino.hr/salons-promo/'
				}
			}
		}
		case 'cs':
		default: {
			const desktop = `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-list-small-banner/salon-list-small-banner-cs.jpg`)}`
			const desktopWebP = `${assetsPath}/${require(`../assets/images/cms-fallbacks/salon-list-small-banner/salon-list-small-banner-cs.webp`)}`
			const mobile = desktop
			const mobileWebP = desktopWebP

			return {
				image: {
					...commonImageData,
					desktop,
					mobile,
					desktopWebP,
					mobileWebP,
					link: 'https://bit.ly/3EY9oBt'
				}
			}
		}
	}
}

export const LOGIN_AND_REGISTRATION_BANNER_FALLBACKS = (): CmsLoginAndRegistrationBannerData => {
	const { formatMessage, locale } = getIntl()
	const { assetsPath } = getAppContext()

	const commonImageData = {
		alt: formatMessage({ id: 'cms-fallbacks-login-and-registration-promo-banner-alt' }),
		trackingID: undefined,
		link: undefined
	}

	switch (locale) {
		case 'bg': {
			const url = `${assetsPath}/${require(`../assets/images/cms-fallbacks/login-and-registration-banner/login-and-registration-banner-bg.png`)}`
			const urlWebP = `${assetsPath}/${require(`../assets/images/cms-fallbacks/login-and-registration-banner/login-and-registration-banner-bg.webp`)}`

			return {
				image: {
					...commonImageData,
					url,
					urlWebP
				}
			}
		}
		case 'hu': {
			const url = `${assetsPath}/${require(`../assets/images/cms-fallbacks/login-and-registration-banner/login-and-registration-banner-hu.png`)}`
			const urlWebP = `${assetsPath}/${require(`../assets/images/cms-fallbacks/login-and-registration-banner/login-and-registration-banner-hu.webp`)}`

			return {
				image: {
					...commonImageData,
					url,
					urlWebP
				}
			}
		}
		case 'ro': {
			const url = `${assetsPath}/${require(`../assets/images/cms-fallbacks/login-and-registration-banner/login-and-registration-banner-ro.png`)}`
			const urlWebP = `${assetsPath}/${require(`../assets/images/cms-fallbacks/login-and-registration-banner/login-and-registration-banner-ro.webp`)}`

			return {
				image: {
					...commonImageData,
					url,
					urlWebP
				}
			}
		}
		case 'sk': {
			const url = `${assetsPath}/${require(`../assets/images/cms-fallbacks/login-and-registration-banner/login-and-registration-banner-sk.png`)}`
			const urlWebP = `${assetsPath}/${require(`../assets/images/cms-fallbacks/login-and-registration-banner/login-and-registration-banner-sk.webp`)}`

			return {
				image: {
					...commonImageData,
					url,
					urlWebP
				}
			}
		}
		case 'cs': {
			const url = `${assetsPath}/${require(`../assets/images/cms-fallbacks/login-and-registration-banner/login-and-registration-banner-cs.png`)}`
			const urlWebP = `${assetsPath}/${require(`../assets/images/cms-fallbacks/login-and-registration-banner/login-and-registration-banner-cs.webp`)}`

			return {
				image: {
					...commonImageData,
					url,
					urlWebP
				}
			}
		}
		case 'de-AT':
		case 'hr':
		default: {
			const url = `${assetsPath}/${require(`../assets/images/cms-fallbacks/login-and-registration-banner/login-and-registration-banner-default.png`)}`
			const urlWebP = `${assetsPath}/${require(`../assets/images/cms-fallbacks/login-and-registration-banner/login-and-registration-banner-default.webp`)}`

			return {
				image: {
					...commonImageData,
					url,
					urlWebP
				}
			}
		}
	}
}

export const PARAMETER_SELECTION_BANNER_FALLBACKS = (): CmsParameterSelectionBannerData => {
	const { formatMessage, locale } = getIntl()
	const { assetsPath } = getAppContext()

	const commonImageData = {
		alt: formatMessage({ id: 'cms-fallbacks-parameter-selection-promo-banner-alt' }),
		link: undefined,
		trackingID: undefined
	}

	switch (locale) {
		case 'bg': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-desktop-bg.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-mobile-bg.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-desktop-bg.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-mobile-bg.webp`)}`
				}
			}
		}
		case 'hu': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-desktop-hu.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-mobile-hu.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-desktop-hu.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-mobile-hu.webp`)}`
				}
			}
		}
		case 'ro': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-desktop-ro.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-mobile-ro.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-desktop-ro.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-mobile-ro.webp`)}`
				}
			}
		}
		case 'sk': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-desktop-sk.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-mobile-sk.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-desktop-sk.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-mobile-sk.webp`)}`
				}
			}
		}
		case 'cs': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-desktop-cs.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-mobile-cs.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-desktop-cs.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-mobile-cs.webp`)}`
				}
			}
		}
		case 'de-AT':
		case 'hr':
		default: {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-desktop-default.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-mobile-default.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-desktop-default.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/parameter-selection-banner/parameter-selection-banner-mobile-default.webp`)}`
				}
			}
		}
	}
}

export const THANK_YOU_PAGE_BANNER_FALLBACKS = (): CmsThankYouPageBannerData => {
	const { formatMessage, locale } = getIntl()
	const { assetsPath } = getAppContext()

	const commonImageData = {
		alt: formatMessage({ id: 'cms-fallbacks-thank-you-page-promo-banner-alt' }),
		trackingID: undefined
	}

	switch (locale) {
		case 'bg': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-desktop-bg.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-mobile-bg.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-desktop-bg.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-mobile-bg.webp`)}`,
					link: 'https://www.notino.bg/mobile-application'
				}
			}
		}
		case 'hu': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-desktop-hu.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-mobile-hu.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-desktop-hu.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-mobile-hu.webp`)}`,
					link: 'https://www.notino.hu/mobile-application'
				}
			}
		}
		case 'ro': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-desktop-ro.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-mobile-ro.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-desktop-ro.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-mobile-ro.webp`)}`,
					link: 'https://www.notino.ro/mobile-application'
				}
			}
		}
		case 'sk': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-desktop-sk.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-mobile-sk.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-desktop-sk.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-mobile-sk.webp`)}`,
					link: 'https://www.notino.sk/mobile-application'
				}
			}
		}
		case 'de-AT': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-desktop-de-AT.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-mobile-de-AT.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-desktop-de-AT.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-mobile-de-AT.webp`)}`,
					link: 'https://www.notino.at/mobile-application'
				}
			}
		}
		case 'hr': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-desktop-hr.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-mobile-hr.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-desktop-hr.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-mobile-hr.webp`)}`,
					link: 'https://www.notino.hr/mobile-application'
				}
			}
		}
		case 'cs': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-desktop-cs.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-mobile-cs.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-desktop-cs.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-mobile-cs.webp`)}`,
					link: 'https://www.notino.cz/mobile-application'
				}
			}
		}
		default: {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-desktop-default.jpg`)}`,
					mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-mobile-default.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-desktop-default.webp`)}`,
					mobileWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/thank-you-page-banner/thank-you-page-banner-mobile-default.webp`)}`,
					link: undefined
				}
			}
		}
	}
}

// NOTE: only desktop version of the banner exists
export const RESERVATION_DETAIL_BANNER_FALLBACKS = (): CmsReservationDetailData => {
	const { locale, formatMessage } = getIntl()
	const { assetsPath } = getAppContext()

	const commonImageData = {
		alt: formatMessage({ id: 'cms-fallbacks-reservation-detail-promo-banner-alt' }),
		link: undefined,
		trackingID: undefined
	}

	switch (locale) {
		case 'bg': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/reservation-detail-banner/reservation-detail-banner-bg.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/reservation-detail-banner/reservation-detail-banner-bg.webp`)}`
				}
			}
		}
		case 'hu': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/reservation-detail-banner/reservation-detail-banner-hu.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/reservation-detail-banner/reservation-detail-banner-hu.webp`)}`
				}
			}
		}
		case 'ro': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/reservation-detail-banner/reservation-detail-banner-ro.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/reservation-detail-banner/reservation-detail-banner-ro.webp`)}`
				}
			}
		}
		case 'sk': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/reservation-detail-banner/reservation-detail-banner-sk.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/reservation-detail-banner/reservation-detail-banner-sk.webp`)}`
				}
			}
		}
		case 'de-AT': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/reservation-detail-banner/reservation-detail-banner-de-AT.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/reservation-detail-banner/reservation-detail-banner-de-AT.webp`)}`
				}
			}
		}
		case 'hr': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/reservation-detail-banner/reservation-detail-banner-hr.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/reservation-detail-banner/reservation-detail-banner-hr.webp`)}`
				}
			}
		}
		case 'cs': {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/reservation-detail-banner/reservation-detail-banner-cs.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/reservation-detail-banner/reservation-detail-banner-cs.webp`)}`
				}
			}
		}
		default: {
			return {
				image: {
					...commonImageData,
					desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/reservation-detail-banner/reservation-detail-banner-default.jpg`)}`,
					desktopWebP: `${assetsPath}/${require(`../assets/images/cms-fallbacks/reservation-detail-banner/reservation-detail-banner-default.webp`)}`
				}
			}
		}
	}
}

export const BANNERS_FALLBACKS = (): CmsBannersData => {
	const { locale, formatMessage } = getIntl()
	const { assetsPath } = getAppContext()

	const commonBannerData = {
		id: 'fallback-banner',
		backgroundImage: `${assetsPath}/${require('../assets/images/cms-fallbacks/banners/banner-1-background.jpg')}`
	}

	const commonImageData = {
		desktopWebP: undefined,
		mobileWebP: undefined,
		alt: formatMessage({ id: 'cms-fallbacks-banner-1-alt' }),
		trackingID: undefined
	}

	switch (locale) {
		case 'bg': {
			return {
				banners: [
					{
						...commonBannerData,

						image: {
							...commonImageData,
							desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/banners/banner-1-bg-desktop.jpg`)}`,
							mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/banners/banner-1-bg-mobile.jpg`)}`,
							link: 'https://www.notino.bg/salons-promo/'
						}
					}
				]
			}
		}
		case 'hu': {
			return {
				banners: [
					{
						...commonBannerData,
						image: {
							...commonImageData,
							desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/banners/banner-1-hu-desktop.jpg`)}`,
							mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/banners/banner-1-hu-mobile.jpg`)}`,
							link: 'https://www.notino.hu/salons-promo/'
						}
					}
				]
			}
		}
		case 'ro': {
			return {
				banners: [
					{
						...commonBannerData,
						image: {
							...commonImageData,
							desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/banners/banner-1-ro-desktop.jpg`)}`,
							mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/banners/banner-1-ro-mobile.jpg`)}`,
							link: 'https://www.notino.ro/salons-promo/'
						}
					}
				]
			}
		}
		case 'sk': {
			return {
				banners: [
					{
						...commonBannerData,
						image: {
							...commonImageData,
							desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/banners/banner-1-sk-desktop.jpg`)}`,
							mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/banners/banner-1-sk-mobile.jpg`)}`,
							link: 'https://www.notino.sk/salons-promo/'
						}
					}
				]
			}
		}
		case 'de-AT': {
			return {
				banners: [
					{
						...commonBannerData,
						image: {
							...commonImageData,
							desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/banners/banner-1-default-desktop.jpg`)}`,
							mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/banners/banner-1-default-mobile.jpg`)}`,
							link: 'https://www.notino.at/salons-promo/'
						}
					}
				]
			}
		}
		case 'hr': {
			return {
				banners: [
					{
						...commonBannerData,
						image: {
							...commonImageData,
							desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/banners/banner-1-default-desktop.jpg`)}`,
							mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/banners/banner-1-default-mobile.jpg`)}`,
							link: 'https://www.notino.hr/salons-promo/'
						}
					}
				]
			}
		}
		case 'cs': {
			return {
				banners: [
					{
						...commonBannerData,
						image: {
							...commonImageData,
							desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/banners/banner-1-cs-desktop.jpg`)}`,
							mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/banners/banner-1-cs-mobile.jpg`)}`,
							link: 'https://www.notino.cz/salons-promo/'
						}
					}
				]
			}
		}
		default: {
			return {
				banners: [
					{
						...commonBannerData,
						image: {
							...commonImageData,
							desktop: `${assetsPath}/${require(`../assets/images/cms-fallbacks/banners/banner-1-default-desktop.jpg`)}`,
							mobile: `${assetsPath}/${require(`../assets/images/cms-fallbacks/banners/banner-1-default-mobile.jpg`)}`,
							link: undefined
						}
					}
				]
			}
		}
	}
}
